export const ACTIONS_SBERMARKET = {
  ADD_PRODUCTS: 'ADD_SBERMARKET_PRODUCTS',
  CHANGE_PRODUCT: 'CHANGE_SBERMARKET_PRODUCT',
  CHANGE_MARKET: 'CHANGE_SBERMARKET_MARKET',
};

export const addSbermarketProducts = (data) => ({
  type: ACTIONS_SBERMARKET.ADD_PRODUCTS,
  data,
});

export const actionChangeSbermarketProduct = (product = {}) => ({
  type: ACTIONS_SBERMARKET.CHANGE_PRODUCT,
  product,
});

export const changeSberMarket = (market) => ({
  type: ACTIONS_SBERMARKET.CHANGE_MARKET,
  market,
});
